export const USERNAME_REGEX = /^[a-z0-9_]{3,20}$/;
export const USERNAME_ERROR_MESSAGE =
  'Username must be 3-20 characters, lowercase letters, numbers, and underscores only';

export const ScheduleLimits = {
  // The booking horizon: the furthest ahead a client can book, in calendar days. The
  // single source of truth for the window — the backend scan ceiling in
  // getNextWorkingDays AND the calendar's furthest selectable day on the frontend.
  // Capped at 28 (not 30) so a far-edge session's +24h `client-followup-book` Cloud
  // Task stays under Cloud Tasks' 720h scheduleTime limit — a 29-day booking overflowed
  // it and the task was silently dropped (BACKEND-15).
  bookingHorizonDays: 28,
  minHoursBeforeClass: 24,
  bufferAroundClassMinutes: 5, // MVP: hardcoded 5-minute buffer before AND after classes
};
